import React from 'react';
import { Typography } from '@mui/material';

import { FilledButton } from 'shared-components/Buttons';
import { Descriptions } from './styles';

const Start = ({ onStart }) => (
  <>
    <Descriptions>
      <Typography
        variant='pl3'>
        Keep track of how your pain and the fatigue impacts on your life over the
        calendar year.
      </Typography>
      <br />
      <br />
      <Typography
        variant='pl3'>
        By answering these questions each time you log-in, we’ll be able to fill
        in the heat map to the right and organize your responses into a report.
      </Typography>
      <br />
      <br />
      <Typography
        variant='pl3'>
        We hope this will help inform conversations with your doctor.
      </Typography>
    </Descriptions>
    <FilledButton
      sx={{
        minWidth : '218px',
        maxWidth : '300px',
        padding  : '15px 60px',
      }}
      background='#00778B'
      height='44px'
      fontFamily='Montserrat'
      onClick={onStart}>
      Start daily survey
    </FilledButton>
  </>
);

export default Start;
